import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    switch: {
      marginLeft: theme.spacing(1)
    }
  }),
)
